'use strict';

module.exports = Odigeo.Model.extend({

    dataUrl: 'getancillariesdebuginfo',

    refreshData: function() {
        this.isEmptyData = false;
        this.refresh();
    },

    url: function() {
        return Odigeo.Settings.getProperty('ancillariesUrlFormatter')(this.dataUrl);
    },

    getDataRequestSettings: function() {
        return {
            type: 'GET',
            data: null,
            success: Odigeo._.bind(this.requestSuccessHandler, this),
        };
    },

    requestSuccessHandler: function(response) {
        if (!Odigeo._.isEmpty(response)) {
            this.set('debuginfo', response);
        }
    },
});
